/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProcessStatisticsDto } from '../models';
/**
 * RestStatisticsApi - axios parameter creator
 */
export const RestStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Każdy proces utworzony w okresie od `from` do `to` (dni lokalne, oba włącznie) z etapem sprzedaży i wartością netto wyliczonymi z jego ofert. Szablony ofert nie wchodzą do wyniku. Filtry osób i źródła oraz agregaty liczy klient. Wymaga uprawnienia MENU_STATISTICS. 
         * @summary Procesy z okresu do statystyk sprzedaży
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessStatistics: async (from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getProcessStatistics', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getProcessStatistics', 'to', to)
            const localVarPath = `/api/statistics/processes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestStatisticsApi - functional programming interface
 */
export const RestStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Każdy proces utworzony w okresie od `from` do `to` (dni lokalne, oba włącznie) z etapem sprzedaży i wartością netto wyliczonymi z jego ofert. Szablony ofert nie wchodzą do wyniku. Filtry osób i źródła oraz agregaty liczy klient. Wymaga uprawnienia MENU_STATISTICS. 
         * @summary Procesy z okresu do statystyk sprzedaży
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessStatistics(from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessStatistics(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestStatisticsApi.getProcessStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestStatisticsApi - factory interface
 */
export const RestStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestStatisticsApiFp(configuration)
    return {
        /**
         * Każdy proces utworzony w okresie od `from` do `to` (dni lokalne, oba włącznie) z etapem sprzedaży i wartością netto wyliczonymi z jego ofert. Szablony ofert nie wchodzą do wyniku. Filtry osób i źródła oraz agregaty liczy klient. Wymaga uprawnienia MENU_STATISTICS. 
         * @summary Procesy z okresu do statystyk sprzedaży
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessStatistics(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessStatisticsDto> {
            return localVarFp.getProcessStatistics(from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestStatisticsApi - interface
 */
export interface RestStatisticsApiInterface {
    /**
     * Każdy proces utworzony w okresie od `from` do `to` (dni lokalne, oba włącznie) z etapem sprzedaży i wartością netto wyliczonymi z jego ofert. Szablony ofert nie wchodzą do wyniku. Filtry osób i źródła oraz agregaty liczy klient. Wymaga uprawnienia MENU_STATISTICS. 
     * @summary Procesy z okresu do statystyk sprzedaży
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessStatistics(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessStatisticsDto>;

}

/**
 * RestStatisticsApi - object-oriented interface
 */
export class RestStatisticsApi extends BaseAPI implements RestStatisticsApiInterface {
    /**
     * Każdy proces utworzony w okresie od `from` do `to` (dni lokalne, oba włącznie) z etapem sprzedaży i wartością netto wyliczonymi z jego ofert. Szablony ofert nie wchodzą do wyniku. Filtry osób i źródła oraz agregaty liczy klient. Wymaga uprawnienia MENU_STATISTICS. 
     * @summary Procesy z okresu do statystyk sprzedaży
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessStatistics(from: string, to: string, options?: RawAxiosRequestConfig) {
        return RestStatisticsApiFp(this.configuration).getProcessStatistics(from, to, options).then((request) => request(this.axios, this.basePath));
    }
}

